<div class="date">
  <div class="day">{{ event.date | date: 'dd' }}</div>
  <div class="month">{{ event.date | date: 'MMM' }}</div>
</div>

<div class="event-info">
  <div class="event-time">
    <mat-icon [svgIcon]="'schedule'" class="square-icon time-icon"></mat-icon>
    <span>{{atTimeText}} {{ event.startTime }} {{upToText}} {{ event.endTime }}</span>
  </div>
  <div class="event-location">
    <mat-icon [svgIcon]="'location-2'" class="square-icon location-icon"></mat-icon>
    {{ event.location }}
  </div>
</div>
